// Product-page heart: adds/removes the product from the visitor's wishlist (stored in this browser's
// localStorage under "randaco:wishlist" as a list of product URLs). Broadcasts "wishlist:change".
const STORAGE_KEY = 'randaco:wishlist';

function readWishlist() {
  try {
    const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return Array.isArray(list) ? list.filter((url) => typeof url === 'string') : [];
  } catch (error) {
    return [];
  }
}

function writeWishlist(list) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch (error) {
    // Storage unavailable (private mode): keep working for this page view only.
  }
  window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list } }));
}

class SWishlistToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.url = this.dataset.productUrl;
    this.status = this.querySelector('[data-wishlist-status]');
    if (!this.button || !this.url) return;

    this.onClick = () => this.toggle();
    this.onChange = () => this.render();
    this.onStorage = (event) => {
      if (event.key === STORAGE_KEY) this.render();
    };
    this.button.addEventListener('click', this.onClick);
    window.addEventListener('wishlist:change', this.onChange);
    window.addEventListener('storage', this.onStorage);
    this.render();
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
    window.removeEventListener('wishlist:change', this.onChange);
    window.removeEventListener('storage', this.onStorage);
  }

  saved() {
    return readWishlist().includes(this.url);
  }

  toggle() {
    const list = readWishlist();
    const index = list.indexOf(this.url);
    const adding = index === -1;
    if (adding) list.unshift(this.url);
    else list.splice(index, 1);
    writeWishlist(list.slice(0, 100));
    if (this.status) this.status.textContent = adding ? this.dataset.addedMessage : this.dataset.removedMessage;
    if (adding && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.button.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }],
        { duration: 320, easing: 'ease-out' },
      );
    }
  }

  render() {
    const saved = this.saved();
    this.toggleAttribute('data-saved', saved);
    this.button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    const baseLabel = saved ? this.dataset.removeLabel : this.dataset.addLabel;
    const label = this.dataset.productTitle ? `${baseLabel}: ${this.dataset.productTitle}` : baseLabel;
    this.button.setAttribute('aria-label', label);
    this.button.title = label;
    const fill = this.querySelector('[data-heart-fill]');
    if (fill) fill.style.fill = saved ? 'currentColor' : 'none';
    this.button.style.color = saved ? 'var(--color-sale)' : '';
    this.button.style.borderColor = saved ? 'var(--color-sale)' : '';
  }
}

if (!customElements.get('s-wishlist-toggle')) customElements.define('s-wishlist-toggle', SWishlistToggle);
